export default __webpack_public_path__ + "static/The Home_Image 5_carousel 3@2x-6c7365c54cdc00d43f948dd5b0d0e9fe.jpg";